import { AlertCircle, RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
      <p className="text-lg font-medium text-gray-700 mb-2">
        Ocurrió un error
      </p>
      <p className="text-sm text-gray-500 max-w-md mb-6">
        {message}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className={cn(
            'inline-flex items-center gap-2 px-5 py-2.5',
            'bg-liec-primary-500 hover:bg-liec-primary-600',
            'text-white font-semibold text-sm',
            'transition-colors duration-200',
            'focus:outline-none focus:ring-2 focus:ring-liec-primary-500 focus:ring-offset-2'
          )}
        >
          <RefreshCw className="w-4 h-4" />
          Reintentar
        </button>
      )}
    </div>
  );
}
